import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'
import { Matching } from '@/features/matching'
import { DEFAULT_RADIUS_KM } from '@/features/matching/components/matching-filters'

const ZodMatchingSearch = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(20),
  radius_km: z.number().optional().catch(DEFAULT_RADIUS_KM),
  min_score: z.number().optional().catch(undefined),
  origin_location_id: z.number().optional().catch(undefined),
  origin_city: z.string().optional().catch(undefined),
  origin_country_code: z.string().optional().catch(undefined),
  destination_location_id: z.number().optional().catch(undefined),
  destination_city: z.string().optional().catch(undefined),
  destination_country_code: z.string().optional().catch(undefined),
  truck_types: z.array(z.string()).optional().catch(undefined),
  load_type: z.string().optional().catch(undefined),
  loading_date_from: z.string().optional().catch(undefined),
  loading_date_to: z.string().optional().catch(undefined),
  max_weight: z.number().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/matching/')({
  validateSearch: ZodMatchingSearch,
  component: Matching,
})
